// @flow
import * as PublicAccountPagesConstant from "../../Constants/PublicAccountPages/publicAccountPagesConstants";

type StateType = {
  formElements: {
    title: string,
    email: string,
    phone: string,
    address: string,
    city: string,
    district: string,
    country: string,
    postal_code: string,
    users: Array<string>
  },
  status: {
    isPosting: boolean,
    isRegisterSuccessful: boolean,
    hasError: boolean
  }
};

type ActionType = {
  type: string,
  payload: Object
};

const initialState = {
  formElements: {
    title: "",
    email: "",
    phone: "",
    address: "",
    city: "",
    district: "",
    country: "",
    postal_code: "",
    users: [""]
  },
  status: {
    isPosting: false,
    isRegisterSuccessful: false,
    hasError: false
  }
};

export default function companyregister(state: StateType = initialState, action: ActionType) {
  switch (action.type) {
    case PublicAccountPagesConstant.COMPANY_REGISTER_FORM_ELEMENT_VALUE_CHANGE:
      return companyRegisterFormElementValueChange(state, action);
    case PublicAccountPagesConstant.COMPANY_REGISTER_FORM_ELEMENT_USER_VALUE_CHANGE:
      return companyRegisterFormElementUserValueChange(state, action);
    case PublicAccountPagesConstant.ADD_NEW_USER_FIELD_TO_COMPANY_REGISTER_FORM:
      return addNewUserFieldToCompanyRegisterForm(state);
    case PublicAccountPagesConstant.REMOVE_USER_FIELD_FROM_COMPANY_REGISTER_FORM:
      return removeUserFieldFromCompanyRegisterForm(state);
    case PublicAccountPagesConstant.COMPANY_REGISTER_FORM_SUBMIT_REQUEST:
      return companyRegisterFormSubmitRequest(state);
    case PublicAccountPagesConstant.COMPANY_REGISTER_FORM_SUBMIT_SUCCESS:
      return companyRegisterFormSubmitSuccess(state);
    case PublicAccountPagesConstant.COMPANY_REGISTER_FORM_SUBMIT_FAILURE:
      return companyRegisterFormSubmitFailure(state);
    case PublicAccountPagesConstant.COMPANY_REGISTER_FORM_ERROR_RELEASE:
      return companyRegisterFormErrorRelease(state);
    default:
      return state;
  }
}

function companyRegisterFormElementValueChange(state, action) {
  const { formElement, value } = action.payload;
  return {
    ...state,
    formElements: {
      ...state.formElements,
      [formElement]: value
    }
  };
}

function companyRegisterFormElementUserValueChange(state, action) {
  const { index, value } = action.payload;
  return {
    ...state,
    formElements: {
      ...state.formElements,
      users: state.formElements.users.map((user, id) => (id === index ? value : user))
    }
  };
}

function addNewUserFieldToCompanyRegisterForm(state) {
  return {
    ...state,
    formElements: {
      ...state.formElements,
      users: state.formElements.users.concat("")
    }
  };
}

function removeUserFieldFromCompanyRegisterForm(state) {
  return {
    ...state,
    formElements: {
      ...state.formElements,
      users: state.formElements.users.slice(0, state.formElements.users.length - 1)
    }
  };
}

function companyRegisterFormSubmitRequest(state) {
  return {
    ...state,
    status: {
      isPosting: true,
      isRegisterSuccessful: false,
      hasError: false
    }
  }
}

function companyRegisterFormSubmitSuccess(state) {
  return {
    ...state,
    status: {
      isPosting: false,
      isRegisterSuccessful: true,
      hasError: false
    }
  }
}

function companyRegisterFormSubmitFailure(state) {
  return {
    ...state,
    status: {
      isPosting: false,
      isRegisterSuccessful: false,
      hasError: true
    }
  }
}

function companyRegisterFormErrorRelease(state) {
  return {
    ...state,
    status: {
      isPosting: false,
      isRegisterSuccessful: false,
      hasError: false
    }
  };
}



// WEBPACK FOOTER //
// ./src/Reducers/PublicAccountPages/companyregister.js